<app-marketplace-header-atom
  title="Tout Food Society"
  (backEvent)="onBackButtonClick()"
  subtitle="Les 10 restaurants en 1 carte"
  imgUrl="assets/images/food-society/marketplace-header-background.jpg"
></app-marketplace-header-atom>

@if (isMarketplaceAvailable$ | async) {
  <div>
    @if (categoryBlocks) {
      <div
        appScrollSpy
        [ids]="idsCategories"
        [activeSection]="tab.id"
        (activeSectionChange)="$event && onTabClick({ tabId: $event })"
      >
        <div
          class="sticky top-0 z-10"
          #categoryTabsContainer
        >
          <app-tab-list-atom
            [treeTabs]="tabCategories"
            [activeItemId]="tab.id"
            (tabChange)="onTabClick($event)"
          ></app-tab-list-atom>
        </div>
        @for (categoryBlock of categoryBlocks; track categoryBlock) {
          <app-component-factory
            [componentClass]="categoryBlock.componentClass"
            [data]="categoryBlock"
          ></app-component-factory>
        }
      </div>
    } @else {
      <div class="pt-8">
        @for (i of [].constructor(200); track $index) {
          <div class="flex h-32 max-w-screen-sm cursor-pointer justify-between bg-white px-5 py-3">
            <div class="w-full">
              <p class="mb-2 h-6 w-32 animate-pulse rounded bg-neutral-200"></p>
              <p class="mb-2 h-4 w-44 animate-pulse rounded bg-neutral-50"></p>
            </div>
            <div class="height-fit-content relative">
              <div class="h-28 w-28 animate-pulse rounded bg-neutral-50"></div>
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="mx-auto my-5 max-w-screen-sm px-5 py-5">
    <p class="rounded rounded-sm bg-highlight-50 p-4 font-accent">
      {{ 'shop-page.order-not-available' | translate }}
    </p>
  </div>
}
